export enum ResearchEntityRequestStatus {
    Pending = 'PENDING',
    Completed = 'COMPLETED',
}
